// client/src/components/TeamsScreen.js
import { useFetch } from '../hooks/useFetch';

// Note the symmetry with HomeScreen — same three-state structure, same
// imports, same shape. That symmetry is the abstraction working.
// The only differences are: which endpoint, and what JSX renders the data.
export function TeamsScreen() {
  const { data: teams, loading, error } = useFetch('/teams');

  if (loading) {
    return <div style={{ padding: 20, fontFamily: 'sans-serif' }}>Loading teams…</div>;
  }

  if (error) {
    return (
      <div style={{ padding: 20, fontFamily: 'sans-serif', color: 'crimson' }}>
        <h2>Couldn't load teams</h2>
        <pre>{error}</pre>
      </div>
    );
  }

  // Defensive empty-state branch. /teams could return `data: []` for an
  // org with no teams configured yet. We don't expect this today (MCYH
  // has 3 seed teams), but coding for it now is cheap and prevents the
  // "empty list looks identical to broken endpoint" confusion later.
  if (teams.length === 0) {
    return (
      <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
        <h1>Teams</h1>
        <p style={{ color: '#666' }}>No teams found for this organization.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h1>Teams</h1>
      <ul>
        {teams.map((t) => (
          <li key={t.id} style={{ marginBottom: 8 }}>
            <strong>{t.name}</strong>
            {t.tier && <span> — {t.tier}</span>}
            <span style={{ color: '#666' }}>
              {' '}({t.age_group_name} {t.sport_name})
            </span>
          </li>
        ))}
      </ul>

      <details style={{ marginTop: 24 }}>
        <summary>Raw /teams response (debug)</summary>
        <pre style={{ background: '#f4f4f4', padding: 12, fontSize: 12 }}>
          {JSON.stringify(teams, null, 2)}
        </pre>
      </details>
    </div>
  );
}